import { Colors } from '@blueprintjs/core';
import styled from 'styled-components';

export const Description = styled.p`
    tex-align: left;
    color: ${Colors.GRAY1};
    font-size: small;
`;
